import { gql } from "@apollo/client/core";

export default gql`
  query AdminCo2XlsxExport(
    $entityIds: [String!]
    $dateFrom: String!
    $dateTo: String!
  ) {
    getDatapointsAsXlsxAdmin(
      entityIds: $entityIds,
      dateFrom: $dateFrom,
      dateTo: $dateTo,
      onlyCo2: true,
    )
  }
`;
